import React, { Component } from 'react';
import { connect } from 'react-redux';
import ButtonLink from '../utility/ButtonLink';
import ErrorDisplay from '../utility/ErrorDisplay';
import LottieLoader from '../utility/LottieLoader';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { productPurchaseGA } from '../../js/analytics';
import TagManager from 'react-gtm-module';

import {
  fetchBookingStatus,
  toggleProceedToPayment
} from '../../actions/booking';

import { clearApiError } from '../../actions/api';

class BookingSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initData: false
    };
    this.initData = this.initData.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this._isMounted = true;
    this.props.clearApiError();
    this.props.toggleProceedToPayment(false);
    this.initData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async initData() {
    const { fetchBookingStatus } = this.props;
    await fetchBookingStatus();
    const { error } = this.props;
    if (!error && this._isMounted) {
      // Track a purchase via Google Analytics if success
      const { bookingStatus } = this.props;
      productPurchaseGA(bookingStatus.trip_title, bookingStatus.booking_no);
      this.setState({
        initData: true
      });
      // Send payment event to Google Tag Manager
      TagManager.dataLayer({
        dataLayer: {
          page: window.location.pathname,
          event: (bookingStatus.status_code === 1) ? 'payment-success' : 'payment-fail'
        }
      });
    }
    else if(error && this._isMounted){
      // Send payment event to Google Tag Manager
      TagManager.dataLayer({
        dataLayer: {
          page: window.location.pathname,
          event: 'payment-fail'
        }
      });
    }
  }

  render() {
    const { initData } = this.state;
    const { error, bookingStatus, loading, t } = this.props;
    if (error) {
      return <ErrorDisplay error={error} />;
    }
    if (loading || !initData) {
      return (
        <>
          <LottieLoader />
        </>
      );
    }
    if (bookingStatus.status_code === 1) {
      return (
        <div className='fe-booking-summary'>
          <div className='container'>
            <div className='row justify-content-md-center'>
              <div className='col-lg-8'>
                <h1 className='fe-heading'>{t('trip:bookingStatus')}</h1>
                <div className='fe-booking-summary-status'>
                  {bookingStatus.status}
                </div>
                <div className='fe-booking-summary-id'>
                  {t('trip:bookingId')}: {bookingStatus.booking_no}
                </div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t('trip:congratulations', {
                      package: `<span>${bookingStatus.trip_title}</span>`
                    })
                  }}
                />
                <a className='fe-link' href='/getaways'>
                  {t('gen:viewOtherGetaways')}
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className='fe-booking-summary'>
        <div className='container'>
          <div className='row justify-content-md-center'>
            <div className='col-lg-8'>
              <h1 className='fe-heading'>{t('trip:bookingStatus')}</h1>
              <div className='fe-booking-summary-status fail'>
                {bookingStatus.status}
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('trip:bookingFailed', {
                    email:
                      '<a class="fe-link" href="mailto:sdacford@simedarby.com">sdacford@simedarby.com</a>',
                    contactNo: '1-800-18-1828'
                  })
                }}
              />
              <div className='fe-booking-summary-buttons'>
                {/* <ButtonLink to='/getaways'>{t('gen:goHome')}</ButtonLink> */}
                <a href='/getaways'>{t('gen:goHome')}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BookingSummary.propTypes = {
  bookingStatus: PropTypes.object.isRequired,
  error: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  clearApiError: PropTypes.func.isRequired,
  fetchBookingStatus: PropTypes.func.isRequired,
  toggleProceedToPayment: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = ({ bookingState, apiState }) => ({
  bookingStatus: bookingState.bookingStatus,
  error: apiState.error,
  loading: bookingState.loading
});

const mapDispatchToProps = {
  fetchBookingStatus,
  clearApiError,
  toggleProceedToPayment
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(BookingSummary)
);
